/**
 * @ngdoc    overview
 * @name     csm.text
 * @description
 * Text manipulation utilities.
 **/
import angular from 'angular';
import { templateTextBuilderFactory } from './TemplateTextBuilder';
import { textStrings } from './TextStrings';

export default angular
  .module('csm.text', [])
  .factory('TemplateTextBuilder', templateTextBuilderFactory)
  .service('TextStrings', textStrings).name;
